export const CookieTypes = {
  EmailLink: "emailLink",
  Authorization: "authorization",
};
